import moment from "moment";
import { PartnershipBaseEntity, PartnershipEntity } from "../entities/PartnershipEntity";
import { PartnershipFormData, PartnershipInfraOwner } from "@/@types/dtos/partnerships.types";

export class BasePartnership {

  id: string;
  name: string;
  logo: string;
  is_third_party_infra: boolean
  infra_owner: string
  modality: string

  constructor(partnership: PartnershipBaseEntity) {

    const getLogo = () => {
      if (partnership.logo_path) {
        return `${process.env.VUE_APP_IMAGE_BASE_URL}${partnership.logo_path}`
      }
      return require('@/presentation/assets/img/logo-square.svg')
    }


    this.id = partnership.id;
    this.name = partnership.name
    this.infra_owner = partnership.infra_owner
    this.is_third_party_infra = partnership.infra_owner == PartnershipInfraOwner.partner
    this.modality = partnership.infra_owner == PartnershipInfraOwner.partner ? 'Parceiro' : 'Greezon'
    this.logo = getLogo()
  }
}
